import { computed, Directive, effect, inject, input, signal } from '@angular/core';
import { DocumentService } from '../services/document-service';
import { DocumentItem } from './interfaces';
import { BaseTask } from './base-task-directive';

@Directive()
export abstract class Document extends BaseTask {
  targetIndex = input<string>('');
  hasError = signal(false);
  loadingMessage = signal('Caricamento documenti...');
  documents = signal<DocumentItem[]>([]);
  currentPath = signal<string>('input/');
  selectedItems = signal<DocumentItem[]>([]);

  protected readonly documentService = inject(DocumentService);
  
  abstract status: string;

  constructor() {
    super();
    effect(() => {
      const idx = this.targetIndex();
      if (idx) {
        this.currentPath.set(`${this.status}/${idx}/`);
        this.getPendingTask(idx, 'DOCUMENT_INGESTION');
      } else {
        this.currentPath.set(`${this.status}/`);
      }
    });
  }

  rootFolderName = computed(() => {
    if (this.targetIndex()) return this.targetIndex();
    const segments = this.currentPath().split('/').filter((s: string) => s.length > 0);
    const index = segments.length >= 2 ? segments[1] : null;

    if (index) this.getPendingTask(index, 'DOCUMENT_INGESTION');
    return index;
  });

  isInFolder = computed(() => this.currentPath().split('/').filter((s: string) => s.length > 0).length >= 2);

  canRunIngestion = computed(() => {
    const path = this.currentPath();
    const segments = path.split('/').filter((s: string) => s.length > 0);
  
    if (segments.length < 2) return false;
    
    const hasDocuments = this.documents().some((doc: DocumentItem) => doc.percorso.startsWith(path) && doc.percorso !== path);
    const hasSelection = this.selectedItems().length > 0;

    return hasDocuments && hasSelection;
  });

  onTaskEventTriggered() {
    const index = this.rootFolderName();
    if (index) {
      this.getPendingTask(index, 'DOCUMENT_INGESTION');
    }
  }

  loadData() {
    this.isLoading.set(true);
    this.hasError.set(false);

    this.documentService.getDocuments(this.status).subscribe({
      next: (data) => {
        this.documents.set(data);
        this.isLoading.set(false);
      },
      error: (err) => {
        console.error(`Errore durante il recupero dei documenti (${this.status}):`, err);
        this.hasError.set(true);
        this.isLoading.set(false);
      }
    });
  }

  onSelectionChanged(items: DocumentItem[]) {
    this.selectedItems.set(items);
  }
}